// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

// import { useSyncExternalStore } from 'use-sync-external-store/shim';
import { useSyncExternalStoreWithSelector } from 'use-sync-external-store/shim/with-selector';

import { initializeUseSelector } from './hooks';
// import { initializeConnect } from './create-store';

initializeUseSelector(useSyncExternalStoreWithSelector);
// initializeConnect(useSyncExternalStore);

export * from './hooks';
export * from './create-store';
export * from './create-context-store';
export * from './create-transform';
export * from './provider';
export * from './use-local-store';
export * from './helpers';
